<template>
  <div>
    <div id="welcome_modal" class="modal modal--roundended modal--welcomeback modal--zero-balance">
      <div class="modal__content">
        <div class="modal__header ">
          <h1>{{ getTranslations.home_modals_loading_please_wait }}</h1>

          <div class="modal__body my-5">
            <div class="loader-contv1 ">
              <div class="loader-cont__wrapper">
                <div class="loader"></div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal__footer"></div>
      </div>
    </div>

    <div class="modal-overlay-2" style="display: block"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'loader',
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/Loader.vue